import React from 'react';
export function TestingSection() {
  return <div className="space-y-6" data-id="element-276">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-277">
        Putting It To The Test... (Oh Boy Was I Surprised)
      </h2>
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-278">
        <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/6_holding_cbf_and_smiling.png?v=1762445483" alt="Woman smiling and holding device" className="w-full h-full object-cover rounded-lg" data-id="element-279" />
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-280">
        I'll be honest—I've been burned by "miracle" skincare before. So I went
        into this with healthy skepticism.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-281">
        The device arrived in discreet packaging. It looked clinical and
        professional—not like a gimmicky beauty gadget.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-282">
        The instructions were clear and simple. Load the serum cartridge, glide
        it across your face, done.
      </p>
      <h3 className="text-2xl font-bold text-gray-900 pt-4" data-id="element-283">
        First Impressions: Is It Painless?
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-284">
        The hollow microneedles sound scary, but I barely felt anything. Maybe a
        slight tingling sensation—far less uncomfortable than a dermatologist's
        microneedling session.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-285">
        The serum absorbed instantly. No greasy residue. No pilling. My skin
        just drank it up.
      </p>
      <h3 className="text-2xl font-bold text-gray-900 pt-4" data-id="element-286">
        One Hour Later: Wait... What?
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-287">
        I looked in the mirror and was genuinely shocked.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-288">
        My skin looked... plumper. Like I'd just had a facial. The fine lines
        around my eyes had softened noticeably.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-289">
        I took a before-and-after photo on my phone. The difference was
        undeniable.
      </p>
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-290">
        <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/7_actualbeforeafter1.png?v=1762445481" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-291" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 pt-4" data-id="element-292">
        One Week Later: People Started Noticing
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-293">
        My daughter asked if I'd "done something" to my face.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-294">
        My yoga instructor complimented my "glow."
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-295">
        Even the checkout clerk at the grocery store said I looked radiant.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-296">
        These weren't just polite compliments. People could genuinely see the
        difference.
      </p>
      <h3 className="text-2xl font-bold text-gray-900 pt-4" data-id="element-297">
        One Month Later: This Changed Everything
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-298">
        By my fourth treatment, the transformation was remarkable:
      </p>
      <ul className="list-disc list-inside space-y-2 pl-4" data-id="element-299">
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-300">
          Deep wrinkles around my mouth had visibly reduced
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-301">
          My jawline looked more defined
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-302">
          Those stubborn forehead lines had softened significantly
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-303">
          My skin texture was smoother than it had been in years
        </li>
        <li className="text-lg text-gray-800 leading-relaxed" data-id="element-304">
          That perpetually tired look? Gone.
        </li>
      </ul>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-305">
        I looked like myself again. Actually, I looked better than I had in my
        early 60s.
      </p>
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-306">
        <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/7_actualbeforeafter2.png?v=1762445481" alt="Three-step usage guide" className="w-full h-full object-cover rounded-lg" data-id="element-307" />
      </div>
    </div>;
}